var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTqqq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 683.82788,
    height: 500.00003,
    viewBox: "0 0 180.92944 132.29166",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-6.5449432e-5,-164.70839)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1F1\\uE201  \\uE1F1\\uE202   \\uE1F1\\uE203",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4452",
    transform: "matrix(10.656437,0,0,10.656497,-222.74223,-2175.8406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4464",
    style: {
      strokeWidth: 2.38434362
    },
    d: "m 37.880555,220.76821 -6.186821,-2e-5 v 0.24342 l 5.953988,2e-5 v 1.50283 h 0.232833 z m -0.754004,9.11225 c -0.169334,-0.13758 -0.402167,-0.22225 -0.677334,-0.22225 -1.04775,0 -1.883833,0.77259 -1.883833,1.59809 0,0.49741 0.402167,0.79375 0.92075,0.79375 0.846667,0 1.883833,-0.79375 1.894416,-1.5875 v -7.03792 h -0.253999 z m -6.53339,-9.80016 c -0.01058,-0.0212 -0.01058,-0.0423 -0.01058,-0.0741 0,-0.11641 0.08467,-0.17991 0.179917,-0.17991 h 0.05292 c 0.105834,0.0317 0.148167,0.127 0.148167,0.254 0,0.0529 -0.01058,0.127 -0.04233,0.1905 -0.07408,0.23283 -0.328084,0.32808 -0.433917,0.32808 h -0.28575 c -0.08467,0 -0.1905,0.0317 -0.232833,0.13758 -0.01058,0.0212 -0.01058,0.0318 -0.01058,0.0529 0,0.0635 0.07408,0.0952 0.1905,0.0952 h 0.179917 c 0.148167,0 0.211667,0.13758 0.211667,0.29633 0,0.0847 -0.03175,0.16934 -0.0635,0.254 -0.137584,0.30692 -0.328084,0.381 -0.465667,0.381 -0.105833,0 -0.179917,-0.0317 -0.201083,-0.0423 -0.02117,-0.0212 -0.03175,-0.0317 -0.03175,-0.0423 0,-0.0318 0.02117,-0.0529 0.04233,-0.0741 0.08467,-0.0423 0.148167,-0.127 0.148167,-0.23283 0,-0.14817 -0.116417,-0.26458 -0.264584,-0.26458 -0.116416,0 -0.22225,0.0741 -0.264583,0.1905 -0.01058,0.0423 -0.02117,0.11641 -0.02117,0.16933 0,0.21167 0.148167,0.4445 0.709084,0.4445 0.645583,0 0.8255,-0.34925 0.867833,-0.58208 0.01058,-0.0317 0.01058,-0.0635 0.01058,-0.0952 0,-0.1905 -0.127,-0.32809 -0.137583,-0.34925 -0.01058,-0.0106 -0.02117,-0.0106 -0.02117,-0.0317 0,-0.0212 0.01058,-0.0529 0.05292,-0.0635 0.423333,-0.20109 0.508,-0.42334 0.508,-0.635 0,-0.22225 -0.22225,-0.5715 -0.624417,-0.5715 -0.41275,0 -0.709083,0.1905 -0.709083,0.48683 0,0.14817 0.116417,0.254 0.254,0.254 0.148167,0 0.254,-0.10583 0.264583,-0.24342 z m -0.370581,9.80016 c -0.169334,-0.13758 -0.402167,-0.22225 -0.677334,-0.22225 -1.047749,0 -1.883833,0.77259 -1.883833,1.59809 0,0.49741 0.402167,0.79375 0.92075,0.79375 0.846667,0 1.883833,-0.79375 1.894417,-1.5875 v -7.03792 h -0.254 z m -7.123906,-8.86883 5.8737,-2e-5 v -0.24342 l -6.106534,2e-5 v 1.74625 h 0.232834 z m 0.364628,8.86883 c -0.169333,-0.13758 -0.402166,-0.22225 -0.677333,-0.22225 -1.04775,0 -1.883833,0.77259 -1.883833,1.59809 0,0.49741 0.402167,0.79375 0.92075,0.79375 0.846666,0 1.883833,-0.79375 1.894416,-1.5875 v -7.03792 h -0.254 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTqqq);
export default __webpack_public_path__ + "static/media/tqqq.b42e5583370db60c39913f85916eaaa6.svg";
export { ForwardRef as ReactComponent };